var _defs, _path, _path2, _path3, _path4, _path5, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack183({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.51,8.5H.75C.61,8.5.5,8.28.5,8s.11-.5.25-.5H3.51c.14,0,.25.22.25.5S3.65,8.5,3.51,8.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.24,8.5H4.6c-.13,0-.24-.22-.24-.5s.11-.5.24-.5h.64c.13,0,.24.22.24.5S5.37,8.5,5.24,8.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.67,8.5H6.33c-.14,0-.25-.22-.25-.5s.11-.5.25-.5H9.67c.14,0,.25.22.25.5S9.81,8.5,9.67,8.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.25,8.5H12.49c-.14,0-.25-.22-.25-.5s.11-.5.25-.5h2.76c.14,0,.25.22.25.5S15.39,8.5,15.25,8.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.4,8.5h-.64c-.13,0-.24-.22-.24-.5s.11-.5.24-.5h.64c.13,0,.24.22.24.5S11.53,8.5,11.4,8.5Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 0.5,
    y1: 5.7,
    x2: 15.5,
    y2: 5.7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 0.5,
    y1: 10.3,
    x2: 15.5,
    y2: 10.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack183);
export default __webpack_public_path__ + "static/media/Symbolpack_1_83.f8db8aa768ce569a62e8125ed06b4ff8.svg";
export { ForwardRef as ReactComponent };